import React from 'react';
import PropTypes from 'prop-types';
import { getGtm } from './carouselGA';
import { deepLinkCasino, openCasinoByLink } from '~spa/Utils/WrapperIntegration/Ucf';
import {
    useIsHybrid,
    useIsMobile,
} from '~SpectateStore/hooks/clientStateHooks';

const CasinoCarouselIcon = ({
    iconData,
    children,
    source,
    ...otherProps
}) => {
    const {
        label,
        mobile_game_id: mobileGameId,
        desktop_game_id: desktopGameId,
        native_url: nativeUrl,
        web_app_url: webAppUrl,
    } = iconData;

    const isMobile = useIsMobile();
    const isHybrid = useIsHybrid();

    const handleClick = () => {
        if (nativeUrl) {
            const url = isHybrid ? nativeUrl : webAppUrl;
            openCasinoByLink(url);

            return;
        }

        const gameId = isMobile ? mobileGameId : desktopGameId;
        deepLinkCasino({ id: gameId });
    };

    return (
        <div
            onClick={handleClick}
            data-spectate-product={getGtm(source, label)}
            {...otherProps}>
                {children}
        </div>
    );
};

CasinoCarouselIcon.propTypes = {
    children: PropTypes.node.isRequired,
    iconData: PropTypes.object.isRequired,
    source: PropTypes.string.isRequired,
};

export default CasinoCarouselIcon;
